export enum ERole {
  ROLE_USER = 'ROLE_USER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MGR = 'ROLE_MGR',
  ROLE_RH = 'ROLE_RH',
}
